import { createApi } from '@reduxjs/toolkit/query/react'
import { useAppSelector } from 'app/hooks'
import { store } from 'app/store'
import { API_ENDPOINTS } from 'Constants'
import { method } from 'lodash'
import {
  GetAddonsParam,
  GetPincodeListingParams,
  QuotationGetRequestParam,
  QuotationRequest,
  GetInsurerListingParams,
  GetMiscellaneousListingParams,
  GetInsuranceListingParams,
  IHealthSalesBankParams,
  GetCashlessHospitalsListingParams,
  ProposalRequest,
  ConsentRequest,
  ConsentValidateRequest,
} from 'Models/RequestModels/Health'
import { IGetCkycNumber } from 'Models/RequestModels/Health/ckyc'
import {
  GetAddonRidersListing,
  GetPincodeListingResponse,
  GetQuestionsListingResponse,
  QuotationGetResponse,
  QuotationPostResponse,
  GetInsurerListingResponse,
  GetMiscellaneousListing,
  GetInsuranceListingResponse,
  GetGenericBenefitsListingResponse,
  ProposalPostResponse,
  IHealthSalesReportBank,
  GetCompareFieldsResponse,
  CompareListingRequest,
  CompareListingResponse,
  HealthConsentFormPaymentLinkRequest,
  HealthConsentFormPaymentLinkResponse,
  HealthConsentFormRequest,
  ConsentCheckResponse,
  GetPaymentCheckResponse,
  DMSDataPushRequest,
  DMSDataPushResponse,
  GetCashlessHospitalsListingResponse,
} from 'Models/ResponseModels/Health'
import {
  ConsentResponse,
  IGetCkycNumberResponse,
  IValidateInsurerResponse,
  ValidateOTPConsentResponse,
} from 'Models/ResponseModels/Health/ckycSlice.ds'
import { IHealthSalesItem } from 'Models/ResponseModels/Health/HealthSalesItem'
import { healthUrlQuery } from 'Services/baseQuery'
import { makeQuery } from 'Services/general'

// const getHealthHeaders = () => {
//   const tempHeaders = { 'Content-Type': 'application/json', Source: 'Web', Lang: 'EN' }
//   // if (token) {
//   return {
//     ...tempHeaders,
//     Authorization: 'Token f22ea5d8f5615b76b901026a8c051f0758d1be81',
//   }
//   // }
//   // return tempHeaders
// }

export const healthApi = createApi({
  reducerPath: 'healthApi',
  baseQuery: healthUrlQuery,
  endpoints: (builder) => ({
    getSubRequest: builder.mutation<QuotationPostResponse, QuotationRequest>({
      query: (body: QuotationRequest) => ({
        url: API_ENDPOINTS.HEALTH_QUOTATION,
        method: 'POST',
        body: makeQuery(body),
        // headers: getHealthHeaders(),
      }),
    }),
    getPollingQuotations: builder.query<QuotationGetResponse, QuotationGetRequestParam>({
      query: ({ sub_request_id }) => ({
        url: API_ENDPOINTS.HEALTH_QUOTATION,
        method: 'GET',
        params: {
          sub_request_id,
        },
        // headers: getHealthHeaders(),
      }),
    }),
    getAddons: builder.query<GetAddonRidersListing[], GetAddonsParam>({
      query: ({ insurance_id, plan_type, sum_insured, age, duration, unique_identifier }) => ({
        url: API_ENDPOINTS.HEATH_ADDONS,
        method: 'GET',
        params: {
          insurance_id,
          plan_type,
          sum_insured,
          age,
          duration,
          unique_identifier,
        },
        // headers: getHealthHeaders(),
      }),
    }),
    getPincodeListing: builder.query<GetPincodeListingResponse, GetPincodeListingParams>({
      query: (params: GetPincodeListingParams) => ({
        url: API_ENDPOINTS.HEALTH_PINCODE,
        method: 'GET',
        params: params,
        // headers: getHealthHeaders(),
      }),
    }),
    getSpecificCityPincodeListing: builder.query<
      GetPincodeListingResponse,
      GetPincodeListingParams
    >({
      query: (query: GetPincodeListingParams) => ({
        url: API_ENDPOINTS.HEALTH_SPECIFIC_CITY_PINCODE,
        method: 'GET',
        params: query,
        // headers: getHealthHeaders(),
      }),
      // transformResponse: (response: { data: GetPincodeListingResponse }) => response.data,
    }),

    getGenericSumInsured: builder.query<string[], void>({
      query: () => ({
        url: API_ENDPOINTS.HEALTH_SUMINSURED_GENRIC,
        method: 'GET',
        // headers: getHealthHeaders(),
      }),
    }),
    getInsurerListingPlans: builder.query<GetInsurerListingResponse[], GetInsurerListingParams>({
      query: ({ is_previous_insurer }) => ({
        url: API_ENDPOINTS.HEALTH_INSURER_LISTING,
        method: 'GET',
        params: {
          is_previous_insurer,
        },
        // headers: getHealthHeaders(),
      }),
    }),
    getQuestionListing: builder.query<GetQuestionsListingResponse[], { insurance_id: string }>({
      query: ({ insurance_id }) => ({
        url: API_ENDPOINTS.HEALTH_QUES,
        method: 'GET',
        params: {
          insurance_id,
        },
        // headers: getHealthHeaders(),
      }),
    }),
    getMiscellaneousListing: builder.query<GetMiscellaneousListing, GetMiscellaneousListingParams>({
      query: (params) => ({
        url: API_ENDPOINTS.HEALTH_LIST_MISCELLANEOUS,
        method: 'GET',
        params: params,
        // headers: getHealthHeaders(),
      }),
    }),
    getInsuranceListing: builder.query<GetInsuranceListingResponse[], GetInsuranceListingParams>({
      query: (params) => ({
        url: API_ENDPOINTS.HEALTH_INSURANCE_LISTING,
        method: 'GET',
        params: params,
        // headers: getHealthHeaders(),
      }),
    }),
    getGenericBenefitsListing: builder.query<GetGenericBenefitsListingResponse[], void>({
      query: (params) => ({
        url: API_ENDPOINTS.HEALTH_BENEFITS,
        method: 'GET',
        params: params,
        // headers: getHealthHeaders(),
      }),
    }),
    createProposal: builder.mutation<ProposalPostResponse, ProposalRequest>({
      query: (body: ProposalRequest) => ({
        url: API_ENDPOINTS.HEALTH_PROPOSAL,
        method: 'POST',
        body: makeQuery(body),
        // headers: getHealthHeaders(),
      }),
    }),
    healthSalesBank: builder.query<IHealthSalesReportBank, IHealthSalesBankParams>({
      query: (queryParams) => ({
        url: API_ENDPOINTS.HEALTH_SALES_BANK,
        method: 'GET',
        params: queryParams,
      }),
      keepUnusedDataFor: 0.0001,
    }),
    getCompareFields: builder.query<GetCompareFieldsResponse[], void>({
      query: (params) => ({
        url: API_ENDPOINTS.HEALTH_COMPARE_FIELDS,
        method: 'GET',
        params: params,
      }),
    }),

    compareListing: builder.mutation<CompareListingResponse[], CompareListingRequest>({
      query: (body: CompareListingRequest) => ({
        url: API_ENDPOINTS.HEALTH_COMPARE_LISTING,
        method: 'POST',
        body: makeQuery(body),
      }),
    }),
    healthConsentFormLink: builder.mutation<string, HealthConsentFormRequest>({
      query: (body: HealthConsentFormRequest) => ({
        url: body.resend ? API_ENDPOINTS.HEALTH_CONSENT_RESEND : API_ENDPOINTS.HEALTH_CONSENT,
        method: 'POST',
        body: makeQuery(body),
        // headers: getHealthHeaders(),
      }),
    }),
    healthConsentSubmitFormPaymentLink: builder.mutation<
      HealthConsentFormPaymentLinkResponse[],
      HealthConsentFormPaymentLinkRequest
    >({
      query: (body: HealthConsentFormPaymentLinkRequest) => ({
        url: API_ENDPOINTS.HEALTH_CONSENT_SUBMIT_FORM,
        method: 'POST',
        body: body,
        headers: { 'Content-Type': 'application/json', Source: 'Web', Lang: 'EN' },
      }),
    }),
    DMSDataPush: builder.mutation<DMSDataPushResponse, DMSDataPushRequest>({
      query: (body: DMSDataPushRequest) => ({
        url: API_ENDPOINTS.HEALTH_DMS_DATA_PUSH,
        method: 'POST',
        body: body,
        headers: { 'Content-Type': 'application/json', Source: 'Web', Lang: 'EN' },
      }),
    }),
    getConsentData: builder.query<HealthConsentFormRequest, string>({
      query: (consent_identifier) => ({
        url: API_ENDPOINTS.HEALTH_CONSENT,
        method: 'GET',
        params: {
          consent_identifier: consent_identifier,
        },
        headers: { 'Content-Type': 'application/json', Source: 'Web', Lang: 'EN' },
      }),
    }),
    consentCheck: builder.query<
      ConsentCheckResponse,
      { consent_identifier: string; consent_type: string }
    >({
      query: ({ consent_identifier, consent_type }) => ({
        url: API_ENDPOINTS.CONSENT_CHECK,
        method: 'GET',
        params: {
          consent_identifier: consent_identifier,
          consent_type: consent_type,
        },
        headers: { 'Content-Type': 'application/json', Source: 'Web', Lang: 'EN' },
      }),
    }),
    paymentCheck: builder.query<
      GetPaymentCheckResponse,
      {
        unique_identifier: string
      }
    >({
      query: (params) => ({
        url: API_ENDPOINTS.HEALTH_PAYMENT_CHECK,
        method: 'GET',
        params: params,
      }),
    }),

    bmiCheck: builder.query<
      any,
      {
        height: number
        weight: number
        age: number
        insurance_name: string
      }
    >({
      query: (params) => ({
        url: API_ENDPOINTS.BMI_CHECK,
        method: 'GET',
        params: params,
      }),
    }),
    getCashlessHospitalsListing: builder.query<
      GetCashlessHospitalsListingResponse,
      GetCashlessHospitalsListingParams
    >({
      query: (params) => ({
        url: API_ENDPOINTS.CASHLESS_HOSPITALS,
        method: 'GET',
        params: makeQuery(params),
      }),
    }),

    ckycValidateInsurer: builder.query<IValidateInsurerResponse, { insurance_code: string }>({
      query: (params: { insurance_code: string }) => ({
        url: API_ENDPOINTS.HEALTH_CKYC_VALIDATE,
        method: 'GET',
        params: {
          insurance_id: params.insurance_code,
        },
      }),
    }),
    ckycSendOtp: builder.mutation<any, any>({
      query: ({ ...data }) => ({
        url: API_ENDPOINTS.HEALTH_CKYC_SEND_OTP,
        method: 'POST',
        body: { service_name: 'CKYC-OTP', ...data },
      }),
    }),
    ckycValidateOtp: builder.mutation<any, any>({
      query: ({ ...data }) => ({
        url: API_ENDPOINTS.HEALTH_CKYC_VALIDATE_OTP,
        method: 'POST',
        body: { service_name: 'CKYC-OTP', ...data },
      }),
    }),
    getCkycNumber: builder.mutation<IGetCkycNumberResponse, IGetCkycNumber>({
      query: (payload: IGetCkycNumber) => ({
        url: API_ENDPOINTS.HEALTH_CKYC_NUMBER,
        method: 'POST',
        body: payload,
      }),
    }),
    uploadCkycValidationData: builder.mutation<IGetCkycNumberResponse, FormData>({
      query: (payload: FormData) => ({
        url: API_ENDPOINTS.HEALTH_CKYC_NUMBER,
        method: 'POST',
        body: payload,
      }),
    }),
    createCartId: builder.mutation<
      { error_text?: string; cart_id?: number },
      { unique_identifiers_list: string[] }
    >({
      query: (payload: { unique_identifiers_list: string[] }) => ({
        url: API_ENDPOINTS.HEALTH_CREATE_CART,
        method: 'POST',
        body: payload,
      }),
    }),
    updateCart: builder.mutation<
      { error_text?: string; cart_id?: number; cart_update_status?: boolean },
      { unique_identifiers_list: string[]; id: number }
    >({
      query: (payload: { unique_identifiers_list: string[]; id: number }) => ({
        url: API_ENDPOINTS.HEALTH_UPDATE_CART + payload.id,
        method: 'PATCH',
        body: payload,
      }),
    }),
    getHealthSalesReport: builder.query<
      {
        result: IHealthSalesItem[]
        total_count: number
      },
      // void
      // IHealthSalesItem[],
      IHealthSalesItem
    >({
      query: (filters) => ({
        url: API_ENDPOINTS.HEALTH_SALES_REPORT,
        method: 'GET',
        params: filters,
        // rawResponse: true,
      }),
    }),
    sendOTPForConsent: builder.mutation<ConsentResponse, ConsentRequest>({
      query: (payload: ConsentRequest) => ({
        url: API_ENDPOINTS.OTP_CONSENT,
        method: 'POST',
        body: makeQuery(payload),
      }),
    }),
    validateOTPForConsent: builder.mutation<ValidateOTPConsentResponse, ConsentValidateRequest>({
      query: (payload: ConsentValidateRequest) => ({
        url: API_ENDPOINTS.OTP_VALIDATE_CONSENT,
        method: 'POST',
        body: makeQuery(payload),
      }),
    }),
    getDeductibleList: builder.query<string[], { sum_insured: string }>({
      query: (data) => ({
        url: API_ENDPOINTS.GET_DEDUCTIBLE_LIST,
        method: 'GET',
        params: data,
      }),
    }),
  }),
})

export const {
  useGetSubRequestMutation,
  useGetPollingQuotationsQuery,
  useLazyGetAddonsQuery,
  useGetPincodeListingQuery,
  useGetGenericSumInsuredQuery,
  useLazyGetGenericSumInsuredQuery,
  useGetInsurerListingPlansQuery,
  useGetQuestionListingQuery,
  useLazyGetQuestionListingQuery,
  useGetMiscellaneousListingQuery,
  useLazyGetMiscellaneousListingQuery,
  useLazyGetPincodeListingQuery,
  useLazyGetInsuranceListingQuery,
  useGetGenericBenefitsListingQuery,
  useCreateProposalMutation,
  useHealthSalesBankQuery,
  useLazyGetCompareFieldsQuery,
  useCompareListingMutation,
  useHealthConsentFormLinkMutation,
  useHealthConsentSubmitFormPaymentLinkMutation,
  useLazyGetConsentDataQuery,
  useConsentCheckQuery,
  useLazyConsentCheckQuery,
  usePaymentCheckQuery,
  useLazyPaymentCheckQuery,
  useLazyBmiCheckQuery,
  useDMSDataPushMutation,
  useLazyGetCashlessHospitalsListingQuery,
  useLazyGetSpecificCityPincodeListingQuery,
  useGetCkycNumberMutation,
  useLazyCkycValidateInsurerQuery,
  useUploadCkycValidationDataMutation,
  useCreateCartIdMutation,
  useUpdateCartMutation,
  useGetHealthSalesReportQuery,
  useSendOTPForConsentMutation,
  useValidateOTPForConsentMutation,
  useLazyGetDeductibleListQuery,
  useCkycSendOtpMutation,
  useCkycValidateOtpMutation
} = healthApi
